export enum Theme {
	system = "system",
	light = "light",
	dark = "dark",
}
